<template>
  <div id="app" class="h-full">
    <div class="h-full w-full overflow-y-auto">
      <router-view />
    </div>
    <GlobalAlert />
    <ToastContainer ref="toast" />
    <UserProfileDrawer ref="userProfileDrawerRef" />
    <NotificationsDrawer ref="notificationsDrawerRef" />
  </div>
</template>

<script>
import { DefaultLayout } from "@/widgets/app-layout";

// import { getLocaleById } from "@/shared/config/i18n";
import GlobalAlert from "@/shared/ui/custom/alert/GlobalAlert.vue";
import ToastContainer from "@/shared/ui/toast/ToastContainer.vue";
import { UserProfileDrawer } from "@/widgets/user-profile-drawer";
import { NotificationsDrawer } from "@/widgets/notifications-drawer";
import moment from "moment";
moment.locale("ru");

export default {
  name: "App",
  components: {
    DefaultLayout,
    GlobalAlert,
    ToastContainer,
    UserProfileDrawer,
    NotificationsDrawer,
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
html,
body {
  min-height: 100%;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif;
}
#app {
  height: 100%;
}

.island-drawer {
  height: calc(100% - 20px) !important;
  top: 10px !important;
  right: 10px !important;
  @apply overflow-hidden rounded-md;
}
</style>
<script setup>
import { ref, computed, watch, onBeforeUnmount, provide } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { centrifugeManager, fetcherEvents } from "@/shared/lib/centrifuge";
import { USER_PROFILE_DRAWER_KEY } from "@/widgets/user-profile-drawer";
import { NOTIFICATIONS_DRAWER_KEY } from "@/widgets/notifications-drawer";
import { useNotificationsRealtime } from "@/features/notifications-panel";
import { useNotificationStore } from "@/entities/notification";
import {
  ensureStatusDictionary,
  resetStatusDictionary,
} from "@/shared/config/statusDictionary";

const userProfileDrawerRef = ref(null);
const notificationsDrawerRef = ref(null);

provide(USER_PROFILE_DRAWER_KEY, {
  open: (userId) => userProfileDrawerRef.value?.open(userId),
  close: () => userProfileDrawerRef.value?.close(),
});

provide(NOTIFICATIONS_DRAWER_KEY, {
  open: () => notificationsDrawerRef.value?.open(),
  close: () => notificationsDrawerRef.value?.close(),
});

const store = useStore();
const userUuid = computed(() => store.getters.get_self_user?.uuid);

const { locale } = useI18n();
ensureStatusDictionary();
watch(locale, () => {
  resetStatusDictionary();
  ensureStatusDictionary();
});

const notificationStore = useNotificationStore();

let unsubscribeFetcher = null;
let stopNotificationsRealtime = null;

function connectFetcher(uuid) {
  if (!uuid || unsubscribeFetcher) return;
  centrifugeManager.init();
  unsubscribeFetcher = centrifugeManager.subscribe(
    `events/FETCHER/${uuid}`,
    (data) => fetcherEvents.emit(data)
  );
}

watch(
  userUuid,
  (uuid, prev) => {
    if (prev && prev !== uuid && unsubscribeFetcher) {
      unsubscribeFetcher();
      unsubscribeFetcher = null;
    }
    if (prev && prev !== uuid && stopNotificationsRealtime) {
      stopNotificationsRealtime();
      stopNotificationsRealtime = null;
      notificationStore.reset();
    }
    if (uuid) {
      connectFetcher(uuid);
      if (!stopNotificationsRealtime) {
        stopNotificationsRealtime = useNotificationsRealtime({
          userUuid: uuid,
        });
      }
    }
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  if (unsubscribeFetcher) {
    unsubscribeFetcher();
    unsubscribeFetcher = null;
  }
  if (stopNotificationsRealtime) {
    stopNotificationsRealtime();
    stopNotificationsRealtime = null;
  }
  fetcherEvents.clear();
});
</script>
